import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { useSeo } from "../lib/ui";

/** One click stops the land alerts. No login, no questions. */
export default function LandAlertStop() {
  const { token } = useParams();
  const [state, setState] = useState("working");

  useSeo({ title: "Stop land alerts — KickStartKenyaFootball", description: "Stop the land alerts." });

  useEffect(() => {
    api.post(`/land-alerts/stop/${token}`).then(() => setState("done")).catch(() => setState("failed"));
  }, [token]);

  return (
    <div className="bg-black py-24" data-testid="land-alert-stop-page">
      <div className="mx-auto max-w-2xl px-5 md:px-10">
        <p className="overline text-ochre">Land alerts</p>
        <h1 className="display-2 mt-5">
          {state === "done" ? "Stopped" : state === "failed" ? "That Link Is Not One Of Ours" : "One Moment"}
        </h1>
        <p className="body-copy mt-6">
          {state === "done"
            ? "You will not get another land alert from us. Nothing else changes, and you can follow a county again any time."
            : state === "failed"
              ? "The link may already have been used. If alerts keep arriving, reply to one of them and we will stop them by hand."
              : "Stopping your alerts."}
        </p>
        <Link to="/lease-comparison" className="btn-ghost mt-8 inline-flex" data-testid="land-alert-stop-back">
          Back to the land tools
        </Link>
      </div>
    </div>
  );
}
